var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ty-circle",style:({'width':_vm.width+'px','height':_vm.width+'px','border-radius':_vm.borderRadius+'px','lineHeight':_vm.lineHeight+'px'}),on:{"click":_vm.clickHandler}},[_vm._t("body")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-238a8086","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ty-circle/TyCircle.vue
// module id = 306
// module chunks = 0